//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import { numeric } from "vuelidate/lib/validators";

export default {
    components: {
        AQModal,
        AQDropdown,
        AQInput
    },
    data() {
        return {
            opened: true,
            showSave: { label: this.$t("liveView.statistics.thresholds.titleButtActions") },
            hasHeaderActions: [],
            showThresholdsDesc: true,
            showThresholdsDescSimulation: true,
            showThresholdsCalcSim: true,
            timeUnit: "",
            inputValue: "",
            showThSimulation: false,
            minValThresholds: 0,
            maxValThresholds: 100,
            thresholdsContainersWidth: {
                ontimeWidth: 0,
                attentionWidth: 0,
                warningWidth: 0
            },
            thresholdsValues: { min: 20, max: 70 },
            showRange: true,
            timeUnitOptions: [
                {
                    label: this.$t("diagrams.components.minutes"),
                    value: "minutes"
                },
                {
                    label: this.$t("diagrams.components.hours"),
                    value: "hours"
                }
            ],
            //
            appThStart: "14.02.2019 at 15:12",
            thresholdAttention: "12hrs and 15 minutes",
            thresholdWarning: "24hrs and 10 minutes",
            thresholdOverdue: "36hrs and 5 minutes"

        };
    },
    computed: {
        ...mapGetters("reports", ["getThresholds"])
    },
    watch: {
        thresholdsValues: {
            handler(v) {
                this.setNewThresholds(v);
            },
            immediate: true
        },
        getThresholds: {
            handler(v) {
                this.thresholdsValues.min = v.lvThresholdFilterModel.attentionPercent;
                this.thresholdsValues.max = v.lvThresholdFilterModel.atRiskPercent;
                this.setNewThresholds(this.thresholdsValues);
            },
            immediate: true
        }
    },

    created() {
    },
    validations: {
        inputValue: {
            numeric
        }
    },

    methods: {
        afterHide() {
            this.opened = false;
            this.$emit("closeThresholds");
        },
        action(action) {
            if (action === "save") {
                this.$store.commit("reports/setThresholds", { lvThresholdFilterModel: { attentionPercent: this.thresholdsValues.min, atRiskPercent: this.thresholdsValues.max } });
            }
            this.afterHide();
        },
        runThresholdSimulation() {
            if (!this.$v.inputValue.$invalid && this.timeUnit) {
                this.showThSimulation = true;
                let richAttention; let richWarning; let richOverdue;
                const currentDate = new Date();
                const month = currentDate.getMonth() + 1;
                const minutes = currentDate.getMinutes() > 9 ? currentDate.getMinutes() : (`0${currentDate.getMinutes()}`);

                this.appThStart = `${currentDate.getDate()}.${month > 9 ? month : (`0${month}`)}.${currentDate.getFullYear()} at ${currentDate.getHours()}:${minutes}`;
                richAttention = (this.inputValue * this.thresholdsValues.min / 100);
                richWarning = (this.inputValue * this.thresholdsValues.max / 100);
                richOverdue = this.inputValue;

                if (this.timeUnit === "hours") {
                    this.thresholdAttention = `${Math.floor(richAttention)}hrs and ${Math.floor(richAttention * 60) % 60}minutes`;
                    this.thresholdWarning = `${Math.floor(richWarning)}hrs and ${Math.floor(richWarning * 60) % 60}minutes`;
                    this.thresholdOverdue = `${this.inputValue}hrs and 0minutes`;
                } else {
                    this.thresholdAttention = `${Math.floor(richAttention / 60)}hrs and ${Math.floor(richAttention % 60)}minutes`;
                    this.thresholdWarning = `${Math.floor(richWarning / 60)}hrs and ${Math.floor(richWarning % 60)}minutes`;
                    this.thresholdOverdue = `${Math.floor(richOverdue / 60)}hrs and ${Math.floor(richOverdue % 60)}minutes`;
                }
            }
        },
        setNewThresholds(v) {
            let dataMin; let
                dataMax;
            this.showThSimulation = false;
            if (v.min < 10) {
                dataMin = 10;
                this.setThresholdValues(10, v.max);
            }
            if (v.max > 90) {
                dataMax = 90;
                this.setThresholdValues(v.min, 90);
            }
            if ((v.max - v.min) < 10) {
                if (this.$refs.rangeControl.dragging.type) {
                    this.setThresholdValues(v.min, v.min + 10);
                } else {
                    this.setThresholdValues(v.max - 10, v.max);
                }
            }
            this.thresholdsContainersWidth.ontimeWidth = `${dataMin || v.min}%`;
            this.thresholdsContainersWidth.attentionWidth = `${(dataMax || v.max) - (dataMin || v.min)}%`;
            this.thresholdsContainersWidth.warningWidth = `${100 - (dataMax || v.max)}%`;
        },
        setThresholdValues(valMin, valMax) {
            this.thresholdsValues.min = valMin;
            this.thresholdsValues.max = valMax;
            this.showRange = false;
            setTimeout(() => {
                this.showRange = true;
            }, 0);
        }
    }
};
